module.exports = __webpack_public_path__ + "static/img/an_2.f1cc573.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/an_2.png
// module id = 824
// module chunks = 1